import { render } from "./DinhMucCoDinhToaXeSection.vue?vue&type=template&id=98e2a79c&ts=true"
import script from "./DinhMucCoDinhToaXeSection.vue?vue&type=script&lang=ts"
export * from "./DinhMucCoDinhToaXeSection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__